import { EventType } from './types';

enum PRETTY_TYPE_BY_TYPE {
  read = 'Trigger',
  write = 'Action',
  search = 'Action',
  search_or_write = 'Action',
  filter = 'Filter',
}

/** Prettifies the type of event */
export const prettyType = (typeOf: keyof typeof PRETTY_TYPE_BY_TYPE) =>
  PRETTY_TYPE_BY_TYPE[typeOf];

enum Category {
  bundle = 'bundle',
  console = 'console',
  errors = 'errors',
}

/** Checks for the type of event */
export const isBundleEvent = (event: EventType) =>
  event.category === Category.bundle;
export const isConsoleEvent = (event: EventType) =>
  event.category === Category.console;
export const isErrorEvent = (event: EventType) =>
  event.category === Category.errors;

/**
 * Text rendered in the clickable row
 *
 * @param event
 * @returns
 */
export const getEventSummary = (event: EventType) => {
  if (isErrorEvent(event) || isConsoleEvent(event) || isBundleEvent(event)) {
    return event.message;
  }

  return `${event.response_status_code || ''} ${event.request_method} ${
    event.request_url || event.request_path
  }`.trim();
};
